import React from 'react'
import './Dialog.css'

export interface DialogProps {
    type: 'error' | 'success' | 'normal';
    title: string;
    message: string;
    btnName: string;
    onClick: () => void
}

const Dialog: React.FC<DialogProps> = ({ type, title, message, btnName, onClick }) => {

    const getStatusClass = () => {
        if (type === "success") return "dialog-title dialog-success";
        if (type === "error") return "dialog-title dialog-error";
        return "dialog-title";
    };

    return (
        <div className="dialog-container">
            <div className="dialog-spacer"></div>
            <div className="dialog-container1">
                <div className="content-container">
                    <h3 className={getStatusClass()}>{title}</h3>
                    <p className="dialog-message">{message}</p>
                </div>
                <div className="dialog-divider"></div>
                <button className="dialog-btn" onClick={onClick}>{btnName}</button>
            </div>
            <div className="dialog-spacer"></div>
        </div>
    )
}

export default Dialog